module.exports = __webpack_public_path__ + "static/media/pos-settlements@2x.6ed89f9d.png";